module.exports = __webpack_public_path__ + "static/media/simbolo-bradesco.6ab0513d.png";